import React from 'react'
import { useApolloClient } from '@apollo/client';
import { usePromptDialogContext } from '../../util/prompt-dialog-context';
import InfoDialogTemplate from '../common/info-dialog-template';
import mutations from '../../graphql/mutations';

const ResetSessionJournalDialog = (props: {
	roomId: string
	onSuccess?: () => void
	onError?: (error: Error) => void
}) =>
{
	const { addDialog } = usePromptDialogContext();
	const apollo = useApolloClient();

	const resetSessionJournal = async () => {
		await apollo.mutate({
			mutation: mutations.resetSessionJournal,
			variables: {
				roomId: props.roomId
			}
		}).then (res => {
			addDialog(<InfoDialogTemplate
				header={'Success!'}
				message={"The space journal was successfully reset."}
			/>);
			if (props.onSuccess) {
				props.onSuccess();
			}
		})
		.catch(err => {
			addDialog(<InfoDialogTemplate
				header={'Failed to reset space journal!'}
				message={(err as Error).message}
			/>);
			if (props.onError) {
				props.onError(err);
			}
		});
	}

	return (
		<InfoDialogTemplate
			header={"Reset?"}
			message={"Are you sure you want to reset the space journal? This will clear history of all actions performed during sessions for this space. This action can not be undone."}
			callbacks={[
				{ callback: () => null, label: 'Cancel' },
				{ callback: resetSessionJournal, label: 'Reset Journal', color: "destructive" }
			]}
		/>
	);
}

export default ResetSessionJournalDialog;
